import {gtmEcommerceOfferTypeMap} from "@pg-rp/common-types";

import {ILeadModalLeadType} from "../../../../application/types/lead/ILeadModalLeadType";
import {ApplicationSourceSection, getApplicationSourceSectionDisplay} from "../../../../application/utils/form/application_form_source";
import {notifyBugsnag} from "../../../../errors/bugsnag/notify_bugsnag";
import {hitGoogleTagManager} from "../../../../tracking/google_tag_manager/hit_google_tag_manager";
import {IGTMEcommerce} from "../../../../tracking/types/ecommerce/IGTMEcommerce";
import {IGTMEcommerceItem} from "../../../../tracking/types/ecommerce/IGTMEcommerceItem";
import {IGtmApplication} from "../../../../tracking/types/IGtmApplication";
import {getCurrencyISOCode} from "../../../../utils/get_currency";
import {getViewTypeName, ViewType} from "../../../../view_type/ViewType";
import {OfferType} from "../../../types/OfferType";
import {formatGtmPhoneNumber} from "../common/format_gtm_phone_number";
import {getGtmEcommerceOfferItemBaseProps} from "../common/get_gtm_ecommerce_offer_item_base_props";
import {getGTMEcommerceOfferRegion} from "../common/get_gtm_ecommerce_offer_region";
import {GTMEcommerceAvailability} from "../types/gtm_ecommerce_availability";
import {GTMEcommerceItemStatus} from "../types/gtm_ecommerce_item_status";
import {IGTMEcommerceAddProductData} from "../types/IGTMEcommerceAddProductData";

export const hitGTMOfferPurchase = (
    data: IGTMEcommerceAddProductData,
    viewType: ViewType | null,
    leadType: ILeadModalLeadType,
    sourceSection: ApplicationSourceSection | string,
    application: IGtmApplication,
    eventCategory?: string
) => {
    const vendorData = (data.vendor && data.vendor.detail) || undefined;
    const offerData = (data.offer && data.offer.detail) || undefined;
    const regionData = (offerData && offerData.region) || undefined;

    if (!vendorData || !offerData || !regionData || !application.uuid) {
        notifyBugsnag(
            JSON.stringify({
                vendor: Boolean(vendorData),
                offer: Boolean(offerData),
                region: Boolean(regionData),
                applicationUuid: Boolean(application.uuid)
            }),
            "hitGTMOfferPurchase missing data"
        );
        return;
    }

    const item = {
        ...getGtmEcommerceOfferItemBaseProps({
            ...offerData,
            vendor: {
                name: vendorData.name
            }
        }),
        item_category: "investment",
        price: 1,
        quantity: 1,
        availability: GTMEcommerceAvailability.IN_STOCK,
        item_status: GTMEcommerceItemStatus.Active,
        item_type: gtmEcommerceOfferTypeMap[offerData.type as OfferType],
        item_source: (typeof sourceSection === "string" ? sourceSection : getApplicationSourceSectionDisplay(sourceSection)) || "na",
        item_list_name: viewType ? getViewTypeName(viewType) : "na",
        item_list_id: leadType?.toString() || "na",
        item_comissioning_date: offerData.construction_date_range.upper || "na",
        ...getGTMEcommerceOfferRegion(regionData),
        variant: "na"
    } as IGTMEcommerceItem;

    const ecommerce: IGTMEcommerce = {
        transaction_id: application.uuid,
        currency: getCurrencyISOCode(offerData.currency),
        value: 1,
        items: [item]
    };

    const nameSegmented = application.name.split(" ");

    hitGoogleTagManager({
        event: "purchase",
        ...(eventCategory ? {event_category: eventCategory} : {}),
        user: {
            email: application.email,
            phone: formatGtmPhoneNumber(application.phone),
            name: nameSegmented?.[0] || "",
            surname: nameSegmented?.[1] || ""
        },
        ecommerce
    });
};
import {gtmEcommerceOfferTypeMap} from "@pg-rp/common-types";

import {ILeadModalLeadType} from "../../../../application/types/lead/ILeadModalLeadType";
import {ApplicationSourceSection, getApplicationSourceSectionDisplay} from "../../../../application/utils/form/application_form_source";
import {notifyBugsnag} from "../../../../errors/bugsnag/notify_bugsnag";
import {hitGoogleTagManager} from "../../../../tracking/google_tag_manager/hit_google_tag_manager";
import {IGTMEcommerce} from "../../../../tracking/types/ecommerce/IGTMEcommerce";
import {IGTMEcommerceItem} from "../../../../tracking/types/ecommerce/IGTMEcommerceItem";
import {IGtmApplication} from "../../../../tracking/types/IGtmApplication";
import {getCurrencyISOCode} from "../../../../utils/get_currency";
import {getViewTypeName, ViewType} from "../../../../view_type/ViewType";
import {OfferType} from "../../../types/OfferType";
import {formatGtmPhoneNumber} from "../common/format_gtm_phone_number";
import {getGtmEcommerceOfferItemBaseProps} from "../common/get_gtm_ecommerce_offer_item_base_props";
import {getGTMEcommerceOfferRegion} from "../common/get_gtm_ecommerce_offer_region";
import {GTMEcommerceAvailability} from "../types/gtm_ecommerce_availability";
import {GTMEcommerceItemStatus} from "../types/gtm_ecommerce_item_status";
import {IGTMEcommerceAddProductData} from "../types/IGTMEcommerceAddProductData";

export const hitGTMOfferPurchase = (
    data: IGTMEcommerceAddProductData,
    viewType: ViewType | null,
    leadType: ILeadModalLeadType,
    sourceSection: ApplicationSourceSection | string,
    application: IGtmApplication,
    eventCategory?: string
) => {
    const vendorData = (data.vendor && data.vendor.detail) || undefined;
    const offerData = (data.offer && data.offer.detail) || undefined;
    const regionData = (offerData && offerData.region) || undefined;

    if (!vendorData || !offerData || !regionData || !application.uuid) {
        notifyBugsnag(
            JSON.stringify({
                vendor: Boolean(vendorData),
                offer: Boolean(offerData),
                region: Boolean(regionData),
                applicationUuid: Boolean(application.uuid)
            }),
            "hitGTMOfferPurchase missing data"
        );
        return;
    }

    const item = {
        ...getGtmEcommerceOfferItemBaseProps({
            ...offerData,
            vendor: {
                name: vendorData.name
            }
        }),
        item_category: "investment",
        price: 1,
        quantity: 1,
        availability: GTMEcommerceAvailability.IN_STOCK,
        item_status: GTMEcommerceItemStatus.Active,
        item_type: gtmEcommerceOfferTypeMap[offerData.type as OfferType],
        item_source: (typeof sourceSection === "string" ? sourceSection : getApplicationSourceSectionDisplay(sourceSection)) || "na",
        item_list_name: viewType ? getViewTypeName(viewType) : "na",
        item_list_id: leadType?.toString() || "na",
        item_comissioning_date: offerData.construction_date_range.upper || "na",
        ...getGTMEcommerceOfferRegion(regionData),
        variant: "na"
    } as IGTMEcommerceItem;

    const ecommerce: IGTMEcommerce = {
        transaction_id: application.uuid,
        currency: getCurrencyISOCode(offerData.currency),
        value: 1,
        items: [item]
    };

    const nameSegmented = application.name.split(" ");

    hitGoogleTagManager({
        event: "purchase",
        ...(eventCategory ? {event_category: eventCategory} : {}),
        user: {
            email: application.email,
            phone: formatGtmPhoneNumber(application.phone),
            name: nameSegmented?.[0] || "",
            surname: nameSegmented?.[1] || ""
        },
        ecommerce
    });
};
